<template>
    <div id="app">
        <div class="wrapper">
            <template v-if="$store.state.isLoggedIn">
                <AppHeader></AppHeader>
                <main class="contents">
                    <transition name="pageTransit" mode="out-in" appear>
                        <router-view v-if="$store.state.isLoggedIn" class="contentBox" />
                    </transition>
                </main>
                <AppFooter></AppFooter>
            </template>
            <template v-else-if="$route.path == '/login'">
                <main class="contents">
                    <router-view />
                </main>
                <AppFooter></AppFooter>
            </template>
            <template v-else>
                <router-view />
            </template>
        </div>
    </div>
</template>

<script>
import AppHeader from './Header.vue';
import AppFooter from './Footer.vue';

export default {
    name: 'AppLayout',
    components: {
        AppHeader,
        AppFooter
    }
}
</script>


// WEBPACK FOOTER //
// src/layout/Index.vue